import React from "react";
import styled from "styled-components";
import { Error } from "../../service";

const Textarea = styled.textarea`
  outline: none;
  appearance: none;
  border-radius: 2px;
  font-family: CircularStd-Book, sans-serif;
  font-size: 22px;
  padding: 0.5rem;
  border: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  &:focus {
    border-color: #c7c7c7;
  }
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #cac7c1;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: #cac7c1;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: #cac7c1;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: #cac7c1;
  }
  ${({ isInvalid }) =>
    isInvalid &&
    `
    border-color: #E7040F;
  `};
`;

export default ({ error, ...props }) => (
  <div>
    <Textarea isInvalid={!!error} {...props} className="f6" />
    {error && <Error>{error}</Error>}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/native/Textarea/index.js